import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../toastify/Toast";
import { clearTypeModal, clearTypeOfShowModalType, selectCurrentModalType } from "../../features/modal/modalSlice";
import { useMutationData } from "../api/useMutationData";
import {  resetNewProduct, selectCurrentProductId, selectNewProduct } from "../../features/product/productSlice";
import { handleApiError } from "../../utils/handleApiError";
import { useIsCategoryId } from "../common/useCommon";
import { CATEGORY } from "../../constant/constant";

interface useProductFormProps {
    selectedFile: File | null
}

export function useProductForm({ selectedFile }: useProductFormProps) {

    const dispatch = useDispatch();
    const newProductForm = useSelector(selectNewProduct);
    const selectedProductId = useSelector(selectCurrentProductId);
    const typeModal = useSelector(selectCurrentModalType);
    const isPastries = useIsCategoryId(CATEGORY.pastries.id)
    const { createNewProduct, isLoadingCreateNewProduct, updateProduct, isLoadingUpdateProduct } = useMutationData();

    const handleSaveNewProduct = async () => {

        if (
            !newProductForm.productName ||
            newProductForm.price === 0 ||
            newProductForm.category?.id === 0 ||
            (!isPastries && !newProductForm.size?.id)
        ) {
            showToast("Please fill in all required fields.", "error");
            return;
        }

        const addOnIDs = newProductForm.addOns?.map((item) => item.addonID) ?? [];
        const formData = new FormData();
        
        if(newProductForm.type?.id) {
            formData.append("type", String(newProductForm.type?.id));
        }
        formData.append("categoryID", String(newProductForm.category?.id));
        formData.append("sizeId", String(newProductForm.size?.id ?? 0));
        if (addOnIDs.length > 0) {
            formData.append("addonIDs", JSON.stringify(addOnIDs));
        }
        if(typeModal !== 'newProduct') {
            formData.append("isAvailable", String(newProductForm.isAvailable));
        }

        if (selectedFile) {
            formData.append("image", selectedFile);
        }

        formData.append("productName", newProductForm.productName);
        formData.append("description", newProductForm.description);
        formData.append("price", String(newProductForm.price));

        try {
            if (typeModal === "newProduct") {
                await createNewProduct(formData).unwrap();
                showToast("New product added", "success");
            }

            if (typeModal === "updateProduct") {
                if(!selectedProductId) return
                await updateProduct({
                    productID: selectedProductId,
                    data: formData
                }).unwrap();

                showToast("Product updated", "success");
            }

            dispatch(clearTypeModal());
            dispatch(clearTypeOfShowModalType());
            dispatch(resetNewProduct());

        } catch (err) {
            handleApiError(err, "Something went wrong.");
        }
    };

    return { handleSaveNewProduct, isLoadingCreateNewProduct, isLoadingUpdateProduct };
}